/**
 * BlackboardKey - typed key for type-safe blackboard access.
 */

import type * as THREE from 'three';

/** Typed key for blackboard values. Provides type-safe access to blackboard data. */
export class BlackboardKey<T = any> {
  public readonly name: string;
  public readonly type: string;
  public readonly defaultValue?: T;

  constructor(name: string, type: string, defaultValue?: T) {
    this.name = name;
    this.type = type;
    this.defaultValue = defaultValue;
  }

  static boolean(name: string, defaultValue?: boolean): BlackboardKey<boolean> {
    return new BlackboardKey<boolean>(name, 'boolean', defaultValue);
  }

  static number(name: string, defaultValue?: number): BlackboardKey<number> {
    return new BlackboardKey<number>(name, 'number', defaultValue);
  }

  static string(name: string, defaultValue?: string): BlackboardKey<string> {
    return new BlackboardKey<string>(name, 'string', defaultValue);
  }

  static vector3(name: string, defaultValue?: THREE.Vector3): BlackboardKey<THREE.Vector3> {
    return new BlackboardKey<THREE.Vector3>(name, 'Vector3', defaultValue);
  }

  static actor(name: string, defaultValue?: any): BlackboardKey<any> {
    return new BlackboardKey<any>(name, 'Actor', defaultValue);
  }

  static array<T>(name: string, elementType: string, defaultValue?: T[]): BlackboardKey<T[]> {
    return new BlackboardKey<T[]>(name, `${elementType}[]`, defaultValue);
  }
}